import useRefreshData from "src/hooks/useRefreshData";
import {
  getMaintenanceRequests,
  resetFilterData,
  selectMaintenanceRequestsForExport,
  setExportData,
  setFilterDataField,
  setGridCurrentPage,
} from "src/redux/slices/maintenanceRequestsSlice";
import MaintenanceRequestsGrid from "./MaintenanceRequestsGrid";
import "./MaintenanceRequests.scss";
import { useSelector, useDispatch } from "react-redux";
import SearchField from "src/components/SearchField/SearchField";
import { ReactComponent as ExportIcon } from "../../../assets/icons/export.svg";
import { useTranslation } from "react-i18next";
import MaintenanceRequestsFilter from "./MaintenanceRequestsFilter";
import { useCallback, useEffect, useState } from "react";
import { Button } from "primereact/button";
import { isRtl } from "src/utils/helpers";
import { DownloadViewPrefixes } from "src/resources/enum";
import { MaintenanceRequestsOrderedColumns } from "src/resources/constant";
import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";
import { exportFormattedData } from "src/utils/common";
import VerticalDivider from "src/components/VerticalDivider/VerticalDivider";
import ShowHistoricalData from "src/components/ShowHistoricalData/ShowHistoricalData";
import { setChangeHistoricalDataSource } from "src/redux/slices/sharedSlice";
const MaintenanceRequests = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common"]);

  const [shouldExport, setShouldExport] = useState(false);

  const breadCrumbsPaths = useSelector(
    (state: any) => state.breadCrumb.breadCrumbItems
  );
  const language = useSelector((state: any) => state.lookup.language);
  const { showHistoricalData } = useSelector(
    (state: any) => state.maintenanceRequests.filterData
  );
  const { showHistoricalDataChangeSource } = useSelector(
    (state: any) => state.shared
  );
  const maintenanceRequestsForExport = useSelector(
    selectMaintenanceRequestsForExport
  );

  useRefreshData(getMaintenanceRequests);
 

  useEffect(() => {
    // reset filter data and search text
    dispatch(resetFilterData());
    dispatch(setExportData([]));
  }, []);

  const exportFile = useCallback(() => {
    if (maintenanceRequestsForExport.length > 0) {
      let mappedData = getMappedData(maintenanceRequestsForExport, language);
      exportFormattedData(
        mappedData,
        MaintenanceRequestsOrderedColumns,
        DownloadViewPrefixes.MaintenanceRequests,
        t
      );
    }
  }, [maintenanceRequestsForExport, language, t]);

  useEffect(() => {
    if (shouldExport) {
      exportFile();
      setShouldExport(false);
    }
  }, [exportFile, shouldExport]);

  const exportExcelHandler = (): void => {
    dispatch(getMaintenanceRequests(true) as any).then(() => {
      setShouldExport(true);
    });
  };
  const handleFormFieldChange = (e: any) => {
    const name = e.target.name;
    const value = e.target.checked;
    dispatch(setFilterDataField({ field: name, value }));
  };
  useEffect(() => {
    dispatch(setGridCurrentPage(0));
  }, [dispatch]);

  useEffect(() => {
    if(showHistoricalDataChangeSource === "") return;
    const index = parseInt(showHistoricalDataChangeSource.toString());
    if (index >= 10) //the number that we set in the ShowHistoricalData component
      dispatch(setGridCurrentPage(0));
      dispatch(setChangeHistoricalDataSource(""));
  }, [showHistoricalDataChangeSource]);

  return (
    <div className="py-2">
      <div className="d-flex justify-content-between px-3 align-items-center pb-2">
        {breadCrumbsPaths.length && (
          <h2 className="inner-page-title">
            {t(breadCrumbsPaths[breadCrumbsPaths.length - 1].label)}
          </h2>
        )}
        <div className="inner-page-search gap-2 ">
          <ShowHistoricalData
            handleFormFieldChange={handleFormFieldChange}
            showHistoricalData={showHistoricalData}
          />
          <Button
            className="d-flex gap-2 light-primary-btn m-0"
            label={t("export")}
            icon={<ExportIcon className="m-0" />}
            onClick={exportExcelHandler}
          ></Button>
        </div>
      </div>
      <HorizontalDivider />
      <MaintenanceRequestsFilter />
      <HorizontalDivider />
      <MaintenanceRequestsGrid />
    </div>
  );
};

export default MaintenanceRequests;
function getMappedData(maintenanceRequestsForExport: any, language: any) {
  let mappedData = maintenanceRequestsForExport;
  if (isRtl(language)) {
    mappedData = mappedData.map((maintenanceRequest: any) => ({
      ...maintenanceRequest,
      status: maintenanceRequest?.statusAr || maintenanceRequest?.status,
      sLABreached: maintenanceRequest?.sLABreachedAr,
      typeOfApproval: maintenanceRequest?.onHoldReasonAr,
    }));
  }

  return mappedData;
}
